import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Download, FileText } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-20 px-4 sm:px-6 lg:px-8" data-id="element-178">
      <div className="max-w-4xl mx-auto" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-[2.5rem] shadow-soft-lg border-4 border-white overflow-hidden relative" data-id="element-180">
          {/* Top Banner */}
          <div className="bg-brand-blue text-white text-center py-3 font-bold text-sm tracking-wide uppercase" data-id="element-181">
            Precio Especial de Lanzamiento
          </div>

          <div className="p-8 md:p-12 lg:p-16 flex flex-col md:flex-row gap-12 items-center" data-id="element-182">
            {/* Left: Value Prop */}
            <div className="flex-1 w-full" data-id="element-183">
              <h2 className="text-3xl font-bold mb-4 text-brand-dark" data-id="element-184">
                IA Fácil y Práctica: <br data-id="element-185" />
                <span className="text-brand-blue text-2xl" data-id="element-186">
                  Edición Extendida
                </span>
              </h2>
              <p className="text-brand-text mb-8" data-id="element-187">
                Consigue el acceso total hoy mismo. Todo el material necesario
                para cerrar la brecha digital y asegurar el futuro de tus hijos.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-188">
                {['eBook Completo (43 páginas)', 'Manual del Prompt Maestro', '15 Dinámicas de Juego', 'Diccionario IA-Español', 'Contrato de Honor Familiar'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-189">
                    <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-190" />
                    <span className="font-medium text-brand-dark" data-id="element-191">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Right: Pricing & CTA */}
            <div id="precio" className="flex-1 w-full bg-cream-50 rounded-3xl p-8 text-center border border-cream-200 scroll-mt-24" data-id="element-192">
              <div className="mb-2 text-brand-muted font-medium line-through decoration-red-400/50 decoration-2" data-id="element-193">
                Valor real: $19.95 USD
              </div>
              <div className="text-5xl font-black text-brand-dark mb-6" data-id="element-194">
                $6.39{' '}
                <span className="text-xl text-brand-muted font-medium" data-id="element-195">
                  USD
                </span>
              </div>

              <motion.a href="https://pay.hotmart.com/B105709675A" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-brand-orange hover:bg-brand-orangeHover text-white py-4 px-6 rounded-2xl font-bold text-lg shadow-soft hover:shadow-soft-lg transition-all mb-6 flex flex-col items-center justify-center gap-1" data-id="element-196">
                <span data-id="element-197">¡Quiero mi Guía y Empezar Hoy!</span>
              </motion.a>

              <div className="flex flex-col gap-3 text-sm font-medium text-brand-muted items-center" data-id="element-198">
                <div className="flex items-center gap-2" data-id="element-199">
                  <Download size={16} className="text-brand-blue" data-id="element-200" />
                  Descarga inmediata tras el pago
                </div>
                <div className="flex items-center gap-2" data-id="element-201">
                  <ShieldCheck size={16} className="text-green-500" data-id="element-202" />
                  Pago 100% seguro
                </div>
                <div className="flex items-center gap-2" data-id="element-203">
                  <FileText size={16} className="text-brand-orange" data-id="element-204" />
                  Formato PDF Universal
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}